/***
 * 创建人：李珊
 * 时间：2020-12-28
 * 描述：知识库管理：新增及编辑操作
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { KmsEnum } from '../../../serves/kms-enum';

@Component({
  selector: 'app-knowledge-base-add',
  templateUrl: './knowledge-base-add.component.html',
  styleUrls: ['./knowledge-base-add.component.css']
})
export class KnowledgeBaseAddComponent implements OnInit {
  
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  //数据绑定对象
  knowledgebaseModel: any = { }; 
  //标头提示信息
  headerLoGo: string; 
  // 可选模型选项
  usableModelList:any = [];
  //提交按钮是否禁用
  clickEnable = true; 
  // 当前登录用户所属组织
  orgId:string = '';
  // 当前登录用户绑定的角色
  userRole:string = '';
  constructor(
    private jwt: SwJwtService,
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
  ) { 

  }

  ngOnInit() {
    this.orgId = this.jwt.getToken('orgId');
    this.userRole = this.jwt.getToken('userRole');
    this.clickLoca(this.param["upOrAdd"],this.param["selectedData"]);
  }

  //知识库点击新增 或者 修改
  clickLoca(upOrAdd: string, selectedData: any) {
    //修改操作
    if (upOrAdd == "Edit") {
      //修改提示头
      this.headerLoGo = "编辑知识库信息"
      // 查询知识库信息
      this.kmsService.getknowledgebaseById(selectedData.kgDbId).subscribe(
        data => {
          if (data["code"] == '200') {
            if(data.data){
              this.knowledgebaseModel = data.data;
              this.knowledgebaseModel.isOnline = data.data.isOnline ? 1 : 0;
            }else{
              this.box.danger('未查询到当前知识库信息！');
            }
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    } else {
      // 新增知识库数据 默认绑定知识库基础数据
      this.headerLoGo = "新增知识库信息";
      this.knowledgebaseModel.isOnline = 0;
      this.knowledgebaseModel.baseStatus = 0;
      this.knowledgebaseModel.isCompatibleMode = 0;   // 默认为新项目；为1时为兼容模式,表示是老项目；
    }
    // 查询所有可选的数据模型
    this.queryUsableModelList();
  }

  // 查询所有可选的数据模型
  queryUsableModelList(){
    const params = {
      'approvalStatus':1,
      'orgId': this.orgId,
    }
    this.kmsService.queryApprovedModel(params).subscribe(
      data => {
        if(data.code == '200'){
            this.usableModelList = data.data;
            if(this.usableModelList.length > 0){
              this.usableModelList.forEach(item => {
                item['id'] = item['modelVerId'];
                item['text'] = item['modelName'] + ' v' + item['version'];
              })
            }
        }else{
            this.box.waring(data.msg);
        }
      }
    )
  }

  //提交 保存 或者修改操作
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      if(this.userRole == '超级管理员'){
        this.box.waring('超级管理员不允许创建或修改知识库！');
        return;
      }
      this.clickEnable = false;
      let params = JSON.parse(JSON.stringify(value));
      if(this.param["upOrAdd"] == 'Edit'){
        params['createStatus'] = this.knowledgebaseModel.createStatus;
      }else{
        params['createStatus'] = 1;
        // // 超级管理员创建知识库时默认关联到内部组织
        params['orgId'] = this.orgId;
      }
      params.isCompatibleMode = this.knowledgebaseModel.isCompatibleMode;
      this.kmsService.saveOrUpdateknowledgebase(params).subscribe(
        data => {
          this.clickEnable = true;
          if (data["code"] == '200') {
            this.knowledgebaseModel = data["data"];
            this.box.success('创建成功');
            if(this.param["upOrAdd"] == 'Add'){
              // 知识库绑定组织后，需要刷新头部的知识库选项
              this.jwt.setToKen('isRefreshKgDbs','true');
            }
          }else{
            this.box.waring(data.msg);
          }
        }
      )
      setTimeout(()=>{
        //抛出事件 提示 关闭模态框
        this.modal.toggle();
        this.callback.emit(true);
      },1500);
    }else {
      this.box.waringError('请输入完整且正确的信息')
    }
  }
}
